import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getDefaultLocale, Locale } from '../../utils/locale/locale'

export interface ConfigState {
  adyenApiKey: string
  apiBaseUrl: string
  auth0Audience: string
  auth0ClientId: string
  auth0Domain: string
  documentApiBaseUrl: string
  environment: string
  heapAppId: string
  locale?: Locale
  sentryDSN: string
  unleashClientKey: string
  unleashUrl: string
  uppyTemplateId: string
}

export const initialConfigState: ConfigState = {
  adyenApiKey: '',
  apiBaseUrl: '',
  auth0Audience: '',
  auth0ClientId: '',
  auth0Domain: '',
  documentApiBaseUrl: '',
  environment: '',
  heapAppId: '',
  locale: getDefaultLocale(),
  sentryDSN: '',
  unleashClientKey: '',
  unleashUrl: '',
  uppyTemplateId: '',
}

export const configSlice = createSlice({
  initialState: initialConfigState,
  name: 'config',
  reducers: {
    setLocale(state: ConfigState, { payload }: PayloadAction<Locale>) {
      state.locale = payload
    },
  },
})

export default configSlice.reducer
